module.exports = __webpack_public_path__ + "static/Yandex.Messenger-a89822fe31b8740cb8bb7af0e25134d1.svg";